import React from 'react';
import { useConnect } from '@lore/query-connect';
import Activity from './Activity';

export default function Header(props) {
  const { project } = props;

  const activity = useConnect('tag.byId', {
    id: project.data.activityId
  });

  return (
    <div className="flex flex-col space-y-2">
      {/*<Activity activity={activity} />*/}
      <div className="space-y-0.5">
        <div className="text-lg font-semibold text-cs-gray-900">
          {project.data.title || activity.data.name}
        </div>
        <div className="text-base text-cs-gray-500 line-clamp-3">
          {project.data.interactionDescription || activity.data.description}
        </div>
      </div>
    </div>
  );
}
